import React from "react";
import Scrollspy from "react-scrollspy";
import Slider from "react-slick";
import bannerImg5 from "../../assets/images/greenshine/C.jpg";
import bannerImg6 from "../../assets/images/greenshine/C2.jpg";
import bannerImg7 from "../../assets/images/greenshine/C4.jpg";
import mobile1 from "../../assets/images/greenshine/corn2.jpg";
import bannerImg1 from "../../assets/images/greenshine/img1.jpg";
import bannerImg2 from "../../assets/images/greenshine/img2.jpg";
import bannerImg3 from "../../assets/images/greenshine/img3.jpg";
import bannerImg4 from "../../assets/images/greenshine/img4.jpg";
import About from "../../components/greenshine/home/about";
import Banner from "../../components/greenshine/home/banner";
import ProductAbout from "../../components/greenshine/home/productabout";
import Products from "../../components/greenshine/home/products";
import Footer from "../../components/greenshine/layouts/footer";
import Header from "../../components/greenshine/layouts/header";
import OurProjects from "../../components/greenshine/home/projects";

const HomePage = () => {
  const bannerdata = [
    {
      id: 1,
      bannerImage: bannerImg1,
      mobile: mobile1,
    },
    {
      id: 2,
      bannerImage: bannerImg2,
      mobile: mobile1,
    },
    {
      id: 3,
      bannerImage: bannerImg3,
      mobile: mobile1,
    },
    {
      id: 4,
      bannerImage: bannerImg4,
      mobile: mobile1,
    },
    {
      id: 5,
      bannerImage: bannerImg5,
      mobile: mobile1,
    },
    {
      id: 6,
      bannerImage: bannerImg6,
      mobile: mobile1,
    },
    {
      id: 7,
      bannerImage: bannerImg7,
      mobile: mobile1,
    },
  ];

  let settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
  };
  return (
    <div className="overflow-hidden">
      <Header />
      <Scrollspy
        items={[
          "section-1",
          "section-2",
          "section-3",
          "section-4",
          "section-5",
        ]}
        currentClassName="active"
      >
        <Slider {...settings}>
          {bannerdata?.map((item) => (
            <section className="z-50" id="section-1">
              <Banner bannerImg={item.bannerImage} mobile={item.mobile} />
            </section>
          ))}
        </Slider>
        <section id="section-2">
          <About />
        </section>
        <section id="section-3">
          <Products />
          <ProductAbout />
        </section>
        <section id="section-4">
          <OurProjects />
        </section>
        <section id="section-5">
          <Footer />
        </section>
      </Scrollspy>
    </div>
  );
};

export default HomePage;
